import React, { Component } from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';

import UACodes from './helpers/gaCode';

/**
 * Helper to know if it should hide the footer
 */
import validateFooter from './helpers/validateFooter';

import * as appAction from './actions/appActions';

/**
 * Components that are loaded through code splitting
 */
const Header = Loadable({
  loader: () => import('./components/Header'),
  loading: () => null,
  timeout: 500,
});

const Body = Loadable({
  loader: () => import('./components/Body'),
  loading: () => <div>Loading...</div>,
  delay: 300,
});

const Methodology = Loadable({
  loader: () => import('./components/Methodology'),
  loading: () => null,
});

const Footer = Loadable({
  loader: () => import('./components/Footer'),
  loading: () => null,
});

// Google Analytics events
const GAcodes = UACodes();
if (GAcodes) {
  ReactGA.initialize(GAcodes, {
    debug: false,
  });
}


if (GAcodes) {
  const page = window.location.pathname;
  if (Array.isArray(GAcodes)) {
    GAcodes.forEach((element) => {
      ReactGA.ga(`${element.gaOptions.name}.send`, 'pageview', { page });
    });
  } else {
    ReactGA.pageview(page + window.location.search);
  }
}

class App extends Component {
  async componentDidMount() {
    // Start the upload of the general data of the viz
    const { appActions } = this.props;
    await appActions.getClientInfo();
  }

  render() {
    const { vizInfo, clientInfo, selectedFilters } = this.props;
    /**
    * Function to know if it should hide the footer
    */
    const hideFooter = validateFooter();
    return (
      <div className="app">
        <Header
          title="Traffic Accidents Hotspots"
          location={vizInfo.location}
        />
        <Body />
        <Methodology />
        {hideFooter
          && (
          <Footer
            client={clientInfo}
            ga={ReactGA.ga}
            gaCodes={GAcodes}
            selectedFilters={selectedFilters}
          />
          )
        }
      </div>
    );
  }
}

const propTypes = {
  appActions: PropTypes.objectOf(PropTypes.func).isRequired,
  vizInfo: PropTypes.objectOf(PropTypes.shape).isRequired,
  clientInfo: PropTypes.objectOf(PropTypes.shape).isRequired,
  selectedFilters: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  vizInfo: state.app.vizInfo,
  clientInfo: state.app.clientInfo,
  selectedFilters: state.map.selectedFilters,
});

const mapDispatchToProps = dispatch => ({
  appActions: bindActionCreators(appAction, dispatch),
});
App.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
